// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  #render-page {
    width: 793px !important;
    height: 1121px !important;
    overflow: visible;
    margin: 0 !important;
    float: none !important;
    box-shadow: unset !important;
    display: block;
    page-break-inside: avoid;
    page-break-after: always;
  }
  table {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  h1 {
    page-break-before: always;
    break-before: always;
  }
  .main-wrapper {
    height: unset !important;
    width: unset !important;
  }
  .advance-layout > div {
    display: none;
  }
  .advance-layout #main-body {
    display: block;
    overflow: visible !important;
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 793px !important;
  }
  #main-render {
    height: unset !important;
  }
  #app-mount-point {
    height: unset !important;
  }
  #app-mount-point > div {
    height: unset !important;
  }
  body {
    overflow: visible !important;
    position: unset !important;
    visibility: hidden;
  }
  #section-to-print,
  #section-to-print * {
    visibility: visible;
    -webkit-print-color-adjust: exact !important;
  }
  #section-to-print {
    width: 793px !important;
    height: unset !important;
    overflow: unset !important;
  }
  /* Defining all page breaks */
  a {
    page-break-inside: avoid;
  }
  blockquote {
    page-break-inside: avoid;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    page-break-after: avoid;
    page-break-inside: avoid;
  }
  img {
    page-break-inside: avoid;
    page-break-after: avoid;
  }
  table,
  pre {
    page-break-inside: avoid;
  }
  ul,
  ol,
  dl {
    page-break-before: avoid;
  }
  .entry iframe,
  ins {
    display: none;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
    line-height: 0pt !important;
    white-space: nowrap;
  }
  .embed-youtube,
  .embed-responsive {
    position: absolute;
    height: 0;
    overflow: hidden;
  }
  /** Setting Page settings */
  @page vertical {
    size: A4 portrait;
  }
  @page horizontal {
    size: A4 landscape;
  }
  @page {
    width: 793px;
    height: 1121px;
    max-height: 100%;
    max-width: 100%;
    margin: 0;
    size: A4 portrait;
  }
}
#render-page {
  width: 793px;
  height: 1121px;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  margin-top: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  background-color: white;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
